import { HUMAN_ASSETS, TERRAIN_CHUNK_SIZE } from "./world.js";
import { getWorldHeightAt, getWorldTerrainNormalAt } from "./world-generation.js";
/** Two authored, safe Generation V2 examples near the public start. Meter units;
 * sources match the emitted GLB bulb centers, independently of their emission. */
export const PUBLIC_LIGHT_OBJECTS = Object.freeze([
    { id: "public-light:industrial-lamp:01", assetId: "industrial_lamp_surviving_01", x: 27, z: 20, embedding: 0.06 },
    { id: "public-light:wreck-worklight:01", assetId: "wreck_worklight_01", x: 37, z: 20, embedding: 0.13 },
].map(({ id, assetId, x, z, embedding }) => Object.freeze({
    id, assetId: assetId, siteId: "public-start-lighting",
    category: HUMAN_ASSETS[assetId].category,
    x, y: getWorldHeightAt(x, z) - embedding, z, yaw: 0, scale: 1, tint: 0,
    terrainNormal: getWorldTerrainNormalAt(x, z), terrainAlignment: 0,
    chunkX: Math.floor(x / TERRAIN_CHUNK_SIZE), chunkZ: Math.floor(z / TERRAIN_CHUNK_SIZE),
})));
export const PUBLIC_WORLD_LIGHTS = Object.freeze([
    Object.freeze({
        id: "public-light:industrial-lamp:01", type: "point",
        position: [28.15, PUBLIC_LIGHT_OBJECTS[0].y + 3.14, 20.08],
        color: [1, 0.76, 0.42], intensity: 2.8, radius: 12, flicker: true,
    }),
    Object.freeze({
        id: "public-light:wreck-worklight:01", type: "spot",
        position: [37.59, PUBLIC_LIGHT_OBJECTS[1].y + 0.8, 21.865],
        color: [0.62, 0.82, 1], intensity: 4, radius: 16,
        direction: [0, -0.1, 1], innerCone: Math.PI / 7, outerCone: Math.PI / 3,
    }),
]);
